import SmsConsent from "./SmsConsent";


export default {
    name     : 'dialog_sms_consent',
    component: SmsConsent,
    dialog   : {
        'max-width': "500px"
    }
}
